import { SelectOption } from '../common/components/forms/xp-select.component';

export const ADWORDS_API_VERSIONS: SelectOption[] = [
  {
    text: 'AdsV11',
    value: 'AdsV11',
  },
  {
    text: 'AdsV10',
    value: 'AdsV10',
  },
];
